import axios from "./axios";
import { uploadToS3 } from "./files";
export const getParameter = (section, key) => axios.get(`/implementation/v1/parameter/${section}/${key}`);
export const getParameters = function (advanced) {
  if (advanced === void 0) {
    advanced = false;
  }
  return axios.get(`/implementation/v1/parameter?advanced=${advanced}`);
};
export const updateParameter = (section, key, data) => axios.put(`/implementation/v1/parameter/${section}/${key}`, data);
export const uploadFile = (file, type) => {
  let urlParam = '';
  return axios.post(`/implementation/v1/parameter/uploadFile`, {
    name: file.name,
    type
  }).then(_ref => {
    let {
      data
    } = _ref;
    if (!data) throw new Error('No url provided');
    const newFile = new File([file], data.key, {
      type: file.type
    });
    urlParam = data.urlParam;
    return uploadToS3(data.url, newFile);
  }).then(res => {
    if (res.status === 200) {
      return urlParam;
    } else {
      throw new Error('File upload error');
    }
  });
};